module.exports = __webpack_public_path__ + "static/img/2.ccd9ac1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R401A/2.jpg
// module id = SV23
// module chunks = 1